import request from '../utils/request';

//公告列表
export const noticeListAPI = query => {
	return request({
		url: '/system/notice/queryByType/' + query,
		method: 'get',
	});
};
//公告详情
export const noticeDetailAPI = query => {
    return request({
        url: '/system/notice/' + query,
        method: 'get',
    });
};
// 获取司法鉴定人列表
export const getJdrfcList = params => {
    return request({
        url: '/system/jdrfc/list',
        method: 'get',
        params
    });
}
